import { Component, ElementRef, Input, OnInit, Optional, Renderer2, ViewChild } from '@angular/core';
import { faArrowRight, faBath, faBed, faClock, faCross, faMapMarkerAlt, faPlaneArrival, faPlaneDeparture, faTimes} from '@fortawesome/pro-light-svg-icons';

import * as  moment from 'moment';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { AuthService, CorporateAccountService, IUser } from '@clooper/core';

@Component({
  selector: 'app-view-corporate-account-payment',
  templateUrl: './view-corporate-account-payment.component.html',
  styleUrls: ['./view-corporate-account-payment.component.scss']
})
export class ViewCorporateAccountPaymentComponent implements OnInit {

  @ViewChild('modalContent') modalContent: ElementRef;
  @ViewChild('downloadButton') downloadButton: ElementRef;
  downloadRef = false;
  icons = {
    clock: faClock,
    close: faTimes,
    cancel: faTimes,
    mapMaker: faMapMarkerAlt,
departure: faPlaneDeparture,
        arrival: faPlaneArrival,
            arrowRight: faArrowRight,
    bedBunk: faBed,
        bath: faBath

  }
  // @Input() modalRef?: BsModalRef;
  enquires: any;
  payment: any;
  viewType: string = 'transaction';
  invoiceData: any;
  totalDuration: number = 0;
  user: IUser = this.auth.getAuthorizedUser();
  updatedReceipt: any;
  updatedInvoice: any;
  taxFees: any;
  downloadingInvoice: boolean = false;

  constructor(
    public options: ModalOptions,
        public bsModalRef: BsModalRef,
        private renderer: Renderer2,
        @Optional() private auth: AuthService,
    private service: CorporateAccountService


  ) {
  }

  ngOnInit(): void {

    this.user = this.auth.getAuthorizedUser();

    this.payment = this.options.initialState;
    
    if (this.payment?.viewType === 'invoice') {
      this.viewType = 'invoice';
      this.invoiceData = this.payment?.invoiceData;
      if (this.payment?.autoDownload) {
        setTimeout(() => this.downloadInvoicePDF(), 500);
      }
    } 

    // this.enquires = this.options.initialState;
    // const days = moment(this.enquires.check_out).valueOf() - moment(this.enquires.check_in).valueOf()
    // const nights = moment.duration(days).asDays();
    // this.totalDuration = Math.ceil(nights)
  }

  hideModal() {
    this.bsModalRef.hide();
  }

   // Method to generate and download the PDF
  downloadReceiptAsPDF() {
    this.downloadRef = true;
    this.service.downloadTransactionReceipts(this.user.business?._id, {q:this.payment.transaction.id}).subscribe((res: any) => {
      const decodedString = atob(res.data);
      const d = JSON.parse(decodedString)
      this.updatedReceipt = d[0]
      this.taxFees = this.updatedReceipt?.trip?.booking?.listing?.rent?.tax + this.updatedReceipt?.trip?.booking?.listing?.rent?.charges_fees
      setTimeout(() => {
        // this.renderer.setStyle(this.downloadButton.nativeElement, 'visibility', 'hidden');
      const content = this.modalContent.nativeElement;

      
      html2canvas(content).then((canvas: any) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jspdf('p', 'mm', 'a4');
        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();
        pdf.addImage(imgData, 'PNG', 0, 0, width, height);
        pdf.save('booking_receipt.pdf');
        // this.renderer.removeStyle(this.downloadButton.nativeElement, 'visibility');
      });
      this.downloadRef = false
      }, 2000);
      // const link = document.createElement('a');
        // link.download = `Transaction Receipt.pdf`;
        // link.href = 'data:application/pdf;base64,' + res.data;
        // link.click();
        // Hide download button before capturing PDF content
    })
    // console.log("Receipt Download")
  }

  downloadInvoicePDF() {
    const businessId = this.user?.business?._id || this.user?.business?.id || (typeof this.user?.business === 'string' ? this.user?.business : '');
    const invoiceId = this.invoiceData?._id || this.invoiceData?.id;
    if (!businessId || !invoiceId) {
      console.error('Business ID or Invoice ID missing');
      return;
    }

    this.downloadingInvoice = true;
    this.downloadRef = true;
    this.service.downloadInvoiceReceipt(businessId, { q: invoiceId }).subscribe({
      next: (res: any) => {
        if (res?.data) {
          try {
            const decodedString = typeof res.data === 'string' ? atob(res.data) : null;
            if (decodedString) {
              const d = JSON.parse(decodedString);
              this.updatedInvoice = Array.isArray(d) ? d[0] : d;
            }
          } catch (e) {
            if (typeof res.data === 'object') {
              this.updatedInvoice = Array.isArray(res.data) ? res.data[0] : res.data;
            }
          }
        }
        setTimeout(() => {
          const content = this.modalContent?.nativeElement;
          if (content) {
            html2canvas(content).then((canvas: any) => {
              const imgData = canvas.toDataURL('image/png');
              const pdf = new jspdf('p', 'mm', 'a4');
              const width = pdf.internal.pageSize.getWidth();
              const height = pdf.internal.pageSize.getHeight();
              pdf.addImage(imgData, 'PNG', 0, 0, width, height);
              pdf.save(`invoice_${invoiceId}.pdf`);
              this.downloadRef = false;
              this.downloadingInvoice = false;
            }).catch((err: any) => {
              console.error('Error generating invoice PDF with html2canvas', err);
              this.downloadRef = false;
              this.downloadingInvoice = false;
            });
          } else {
            this.downloadRef = false;
            this.downloadingInvoice = false;
          }
        }, 2000);
      },
      error: (err: any) => {
        console.error('Failed to fetch invoice details from server, generating PDF from view', err);
        setTimeout(() => {
          const content = this.modalContent?.nativeElement;
          if (content) {
            html2canvas(content).then((canvas: any) => {
              const imgData = canvas.toDataURL('image/png');
              const pdf = new jspdf('p', 'mm', 'a4');
              const width = pdf.internal.pageSize.getWidth();
              const height = pdf.internal.pageSize.getHeight();
              pdf.addImage(imgData, 'PNG', 0, 0, width, height);
              pdf.save(`invoice_${invoiceId}.pdf`);
              this.downloadRef = false;
              this.downloadingInvoice = false;
            }).catch((err: any) => {
              console.error('Error generating invoice PDF with html2canvas', err);
              this.downloadRef = false;
              this.downloadingInvoice = false;
            });
          } else {
            this.downloadRef = false;
            this.downloadingInvoice = false;
          }
        }, 2000);
      }
    });
  }

}


